import { render, staticRenderFns } from "./GenericFacetSelector.vue?vue&type=template&id=25030da0&scoped=true"
import script from "./GenericFacetSelector.vue?vue&type=script&lang=js"
export * from "./GenericFacetSelector.vue?vue&type=script&lang=js"
import style0 from "./GenericFacetSelector.vue?vue&type=style&index=0&id=25030da0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25030da0",
  null
  
)

export default component.exports